module.exports = __webpack_public_path__ + "static/media/team-matt.b1ea2780.jpg";